import { LOCALES } from '@marketplace/i18n';

export const landingPageFooter = {
  [LOCALES.ENG]: {
    developer_landing_footer_terms_and_conditions: 'Terms and Conditions',
    developer_landing_footer_best_practices: 'Code of Developer Best Practices',
    developer_landing_footer_privacy_statement: 'Privacy Statement',
    // developer_landing_footer_copyrigths: '© 2025 All rights reserved. Greenway Health, LLC -  ',
    developer_landing_footer_terms_of_service: 'Terms of Service',
    developer_landing_footer_privacy_policy: 'Privacy Policy',
  },
};
